import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import initApp from 'utils/functions/init';
import { Contexts } from 'constants/context';
import PharmaciesAndProductsContainerSelector from 'modules/categories/pharmacies/container/PharmaciesAndProductsContainer/PharmaciesAndProductsContainerSelector';
import { fetchDropdowns } from 'modules/categories/categoriesSlice';
import { useParams } from 'react-router-dom';
import { fetchSelectedealthPlan } from 'modules/healthPlans/healthPlansSlice';

const PharmaciesProvidersPage = () => {
  const dispatch = useDispatch();
  const { healthPlanId } = useParams();

  useEffect(() => {
    initApp(Contexts.Pharmacies);
    dispatch(fetchDropdowns());
    dispatch(fetchSelectedealthPlan(healthPlanId));
  }, [dispatch]);

  return <PharmaciesAndProductsContainerSelector />;
};

PharmaciesProvidersPage.propTypes = {};

PharmaciesProvidersPage.defaultProps = {};

export default PharmaciesProvidersPage;
